import { Link } from '@mui/material';
import { Box } from '@mui/system';
import { FC } from 'react';
import { useEventBus } from '../../../../../../../../hooks/use-event-bus';
import { usePatientProfile } from '../../../../../../../../hooks/use-patient-profile';
import { EventPatientProfile } from '../../../../../../../../types/event-bus';
import { getStatusIcon } from '../../../../../../../shared/alert/status-icon/status-icon-factory';
import { Card } from '../../../../patient-profile-page.styles';
import { StatusList, StatusListItem } from './alerts-section.styles';

export const AlertsSection: FC = () => {
  const { publish } = useEventBus();
  const { patientInfo } = usePatientProfile();

  const responsiblePartyClick = (patientId: number) => {
    publish({
      messageType: 'patientProfile',
      data: { patientId } as EventPatientProfile['data']
    });
  };

  return (
    <Card sx={{ borderColor: '#E9C66D' }}>
      <Box sx={{ height: '8px', background: '#F9BE28' }}></Box>
      <StatusList>
        {!patientInfo?.patientAlerts ||
          (patientInfo.patientAlerts.length === 0 && <StatusListItem text='Patient has no alerts or tasks' />)}
        {patientInfo.patientAlerts &&
          patientInfo.patientAlerts.map((x, i) => (
            <StatusListItem
              key={i}
              text={x.alert}
              icon={getStatusIcon(x.alert).icon}
              iconcolor={getStatusIcon(x.alert).color}
            >
              {x.patientId != patientInfo.id && (
                <Link onClick={() => responsiblePartyClick(x.patientId)} sx={{ marginTop: '6px', display: 'flex' }}>
                  {`${x.firstName} ${x.lastName}`}
                </Link>
              )}
            </StatusListItem>
          ))}
      </StatusList>
    </Card>
  );
};
